import { Link } from "react-router-dom";

/** items: [{ name, path }] — path relative, e.g. "/events". Must match the
 *  BreadcrumbList JSON-LD passed alongside it (see utils/jsonld.js). */
export default function Breadcrumbs({ items, lang }) {
  return (
    <nav aria-label="Breadcrumb" style={{ fontSize: "13px", color: "var(--color-cream-soft)" }}>
      <ol style={{ display: "flex", gap: "0.5rem", listStyle: "none", padding: 0, margin: 0 }}>
        {items.map((item, index) => (
          <li key={item.path}>
            {index < items.length - 1 ? (
              <Link to={`/${lang}${item.path}`}>{item.name}</Link>
            ) : (
              <span aria-current="page">{item.name}</span>
            )}
            {index < items.length - 1 && <span aria-hidden="true"> / </span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
